import {LocationStrategy} from "@angular/common";
import {OnInit, AfterViewInit, Component, EventEmitter, Input, Output} from "@angular/core";
import {AppService} from "@api";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {SistemaService} from "@servicios/Sistema.Service";


@Component({
    selector: 'asignacionevaluacionalumnosforms',
    templateUrl: './asignacionevaluacionalumnomateriaform.component.html',
})

export class AsignacionEvaluacionAlumnosForms implements OnInit, AfterViewInit {
    consulta!: boolean;
    public errorActivo!: boolean;
    entidad: PeriodoEvaluacion;
    @Input() accion!: {accion: string, entidad: any, periodoevaluacionportipoevaluacionid: number};
    @Input() id!: number;
    @Input() identificador!: number;
    @Input() tipoevaluacionid!: number;
    @Output() output = new EventEmitter();

    cambio: boolean = false;

    collapsed = false;
    visualizador: boolean = false;
    procesando: boolean = false;

    DataMaterias: any[];
    selectedRows: any[];

    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService) {
        this.entidad = new PeriodoEvaluacion();

        this.DataMaterias = [];
        this.selectedRows = [];
    }

    ngOnInit() {
        if (this.identificador == 1) {
            this.visualizador = true;
        }
    }

    ngAfterViewInit() {
        this.SetMateria();
    }

    Guardar() {
        if (this.procesando) {
            return;
        }

        if (this.selectedRows.length > 0) {
            this.procesando = true;
            let info = {"cicloid": this.entidad.cicloid, "periodoevaluacionid": this.entidad.periodoevaluacionid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid, "tipoasignacionid": this.accion.entidad.tipoasignacionid, "listamaterias": this.selectedRows};
            this.appService.Post("planeacion/asignacionevaluacion/alumno/guardar/asignacionalumno", info).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                    this.cambio = true;
                    this.output.next(this.cambio);
                }
                this.procesando = false;
            }).catch(() => {
                this.procesando = false;
            })
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Tienes que seleccionar mínimo una materia a evaluar");
        }
    }

    SetMateria() {
        this.appService.Post("planeacion/asignacionevaluacion/alumno/materia/buscar", {"gradoid": this.accion.entidad.gradoid, "cicloid": this.entidad.cicloid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.DataMaterias = res.data;
                if(this.DataMaterias.length > 0){
                    this.SetMateriasPorPeriodoEvaluacion();
                }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen registros asignados");
                }
            }
        })
    }

    SetMateriasPorPeriodoEvaluacion() {
        this.appService.Post("planeacion/asignacionevaluacion/alumno/profesorpormateria", {"cicloid": this.entidad.cicloid, "periodoevaluacionid": this.entidad.periodoevaluacionid, "periodoevaluacionportipoevaluacionportipoasignacionid": this.accion.entidad.periodoevaluacionportipoevaluacionportipoasignacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                for (let valor of res.data) {
                    if(this.identificador == 1){
                        let materia = this.DataMaterias.find(x => x.profesorpormateriaplanestudiosid == valor.profesorpormateriaplanestudiosid);
                        if (materia) {
                            materia.activo = true;
                        }
                    }else{
                        let materia = this.DataMaterias.find(x => x.profesorpormateriaplanestudiosid == valor.profesorpormateriaplanestudiosid);
                        if (materia) {
                            this.selectedRows.push(materia);
                        }
                    }

                }
            }
        })
    }

    contentReady(e: any) {
        if (!this.collapsed) {
            this.collapsed = true;
            e.component.expandRow(['EnviroCare']);
        }
    }

    Salir() {
        if (this.procesando) {
            return;
        }
        this.procesando = true;
        this.output.next();
        // Se resetea después de un pequeño delay para permitir la navegación
        setTimeout(() => {
            this.procesando = false;
        }, 300);
    }
}